var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4306 10.9375C18.9517 10.0366 19.25 8.99063 19.25 7.875C19.25 4.49226 16.5077 1.75 13.125 1.75C9.74225 1.75 7 4.49226 7 7.875C7 11.2577 9.74225 14 13.125 14C14.0644 14 14.9544 13.7885 15.75 13.4106",
    stroke: "#636980",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 9.625C14.0915 9.625 14.875 8.8415 14.875 7.875C14.875 6.9085 14.0915 6.125 13.125 6.125C12.1585 6.125 11.375 6.9085 11.375 7.875C11.375 8.8415 12.1585 9.625 13.125 9.625Z",
    stroke: "#636980"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0625 17.9375L8.5 12",
    stroke: "#636980",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 18.375L3.9375 17.0625M5.6875 15.3125L7 16.625",
    stroke: "#636980",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.7af51f661312695de915972dc5087b4d.svg";
export { ForwardRef as ReactComponent };